define("shared/modifiers/button", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  /**
   * This applies CSS classes to the target element,
   * styling the element like a button, regardless of that element it is.
   *
   * Use this when applying additional dynamic classes to the element,
   * otherwise the dynamic class with override the classes created by the modifier.
   *
   * Examples:
   *
   * Simple Usage:
   *
   * Styles the `div` like a primary button
   * ```
   * <div {{button}}>
   * ```
   *
   * Using options:
   *
   * Styles the `div` like a small outline button that spans the width of it's container
   * ```
   * <div {{button variant="outline" size="small" additional="block"}}></div>
   * ```
   *
   * Using classes:
   *
   * Styles the `div` like a large danger button with rounded corners. Also applies the "some", "extra", and "classes" classes
   * ```
   * <div {{button variant="danger" size="large" additional="rounded" class="some extra classes"}}></div>
   * ```
   *
   */
  class ButtonModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "prefix", 'o--btn');
    }
    get variantClass() {
      const variants = {
        primary: `${this.prefix}--primary`,
        default: `${this.prefix}--default`,
        proceed: `${this.prefix}--proceed`,
        outline: `${this.prefix}--outline`,
        danger: `${this.prefix}--danger`,
        mute: `${this.prefix}--mute`,
        unstyled: `${this.prefix}--a11y`,
        actionLink: `${this.prefix}--actionLink`,
        none: ''
      };
      const variantKey = this.args.named.variant;
      return variantKey ? variants[variantKey] : variants.primary;
    }
    get size() {
      const sizes = {
        small: `${this.prefix}--sm`,
        regular: this.prefix,
        large: `${this.prefix}--lg`,
        none: ''
      };
      if (this.isUnstyled) {
        return sizes.none;
      }
      return this.args.named.size ? sizes[this.args.named.size] : sizes.regular;
    }
    get additional() {
      const additionalOptions = {
        block: `${this.prefix}--block`,
        rounded: `${this.prefix}--r`,
        circle: `${this.prefix}--c`
      };
      return this.args.named.additional ? additionalOptions[this.args.named.additional] : '';
    }
    get classes() {
      const classes = this.args.named.class || '';
      return classes.split(' ').filter(cls => cls.length);
    }
    get isUnstyled() {
      return this.args.named.variant === 'unstyled' || this.args.named.variant === 'actionLink';
    }
    didUpdateArguments() {
      this._removeClasses();
      this._applyClasses();
      this._updatePrevious();
    }
    didInstall() {
      this._applyClasses();
      this._updatePrevious();
    }
    willRemove() {
      this._removeClasses();
    }
    _applyClasses() {
      const classes = [this.variantClass, this.size, this.additional, ...this.classes].filter(cls => cls.length);
      this.element.classList.add(...classes);
    }
    _removeClasses() {
      const classes = [this._previousVariantClass, this._previousSize, this._previousAdditional, ...this._previousClasses].filter(cls => cls.length);
      this.element.classList.remove(...classes);
    }
    _updatePrevious() {
      this._previousVariantClass = this.variantClass;
      this._previousSize = this.size;
      this._previousAdditional = this.additional;
      this._previousClasses = this.classes;
    }
  }
  _exports.default = ButtonModifier;
});